import { theme } from 'styled-tools'
import styled from 'styled-components/macro'

const Container = styled.div`
  color: ${theme('productMultipleImagesText')};
  background-color: ${theme('productMultipleImagesBox')};
  font-size: 0.8125rem;
  padding: 0.2rem 0.7rem;
  border-radius: 50px;
  text-transform: uppercase;
`
export { Container }
